import { Gauge } from '@ant-design/plots';
import React from 'react';
import { createRoot } from 'react-dom/client';
import PlotAutoFit from '../Layout/PlotAutoFit';

const GaugeChart = () => {
  const config = {
    autoFit: true,
    data: {
      target: 159,
      total: 400,
      name: 'score',
      thresholds: [100, 200, 400],
    },
    scale: {
      color: {
        range: ['#F4664A', '#FAAD14', 'green'],
      },
    },
    style: {
      textContent: (target:any, total:any) => ``,
    },
  };
  return  (
  
        <PlotAutoFit>
      {({ width, height }) => (
        <Gauge
          {...config}
          autoFit={false}
          width={width}
          height={height}
        />
      )}
    </PlotAutoFit>

    
  ); 
};
export default GaugeChart;
 